import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.ALL_USERS });
    context.validatePermissions({ isAllowed, preload });
  },
});
